import React, { useEffect, useRef } from 'react';
import { Card, CardContent } from './ui/card';
import { Users, GraduationCap } from 'lucide-react';

export const Team = () => {
  const teamRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('scale-in');
            }, index * 150);
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = teamRef.current?.querySelectorAll('.team-card');
    cards?.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  const teamMembers = [
    {
      name: 'Dr. Ravindra Kachare',
      specialty: 'Orthopedic & Trauma Surgeon',
      image: '/images/RK1.png',
      credentials: 'MBBS, MS. Ortho',
    },
    {
      name: 'Dr. Rahul Dhope',  
      specialty: 'Consulting Diabetologist',
      image: '/images/RD2.png',
      credentials: 'MBBS, Diploma in Diabetology',
    },
    {
      name: 'Dr. Ambadas Deokar',
      specialty: 'General Physician',
      image: '/images/AD4.png',
      credentials: 'MBBS',
    },
    {
      name: 'Dr. Anand Zingade',
      specialty: 'Laparoscopic & Endoscopic Surgeon',
      image: '/images/AZ3.png',
      credentials: 'MBBS, MS Gen. Surgery',
    },
    {
      name: 'Dr. Anil Dudhabhate',
      specialty: 'Ophthalmologist & Retina Surgeon',
      image: '/images/AD5.png',
      credentials: 'MBBS, MS- Ophthalmology, FCPS',
    },
  ];

  return (
    <section className="py-24 bg-[hsl(var(--muted))]" ref={teamRef}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <div className="inline-flex items-center space-x-2 bg-[hsl(var(--primary))]/10 px-4 py-2 rounded-full">
            <Users className="w-5 h-5 text-[hsl(var(--primary))]" />
            <span className="text-sm font-semibold text-[hsl(var(--primary))]">
              Our Medical Team
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-[hsl(var(--foreground))]">
            Meet Our <span className="block mt-2 text-gradient">Directors</span>
          </h2>
          <p className="text-lg text-[hsl(var(--muted-foreground))] max-w-2xl mx-auto">
            Meet our esteemed directors who lead our medical team with expertise and compassion.
          </p>
        </div>

        {/* Team Grid */}
        <div className="flex flex-wrap justify-center gap-8">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="team-card opacity-0"
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <Card className="group overflow-hidden hover:shadow-[var(--shadow-xl)] transition-all duration-500 border-none h-full flex flex-col">
                {/* Image */}
                <div className="relative h-80 overflow-hidden flex-shrink-0">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[hsl(var(--foreground))]/10 via-[hsl(var(--foreground))]/20 to-transparent"></div>
                  
                  {/* Overlay Content */}
                  {/* <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-2xl font-bold mb-1">{member.name}</h3>
                    <p className="text-white/90 font-medium mb-2">{member.specialty}</p>
                    <div className="flex items-center space-x-2 text-sm text-white/80">
                      <GraduationCap className="w-4 h-4" />
                      <span>{member.credentials}</span>
                    </div>
                  </div> */}
                </div>

                {/* Info - Centered and Clean */}
                <CardContent className="p-6 text-center flex-grow flex flex-col justify-center">
                  <div className="space-y-3">
                    <h3 className="text-xl font-bold text-[hsl(var(--foreground))]">
                      {member.name}
                    </h3>
                    <div className="flex items-center justify-center space-x-2 text-[hsl(var(--primary))]">
                      <GraduationCap className="w-4 h-4" />
                      <span className="font-medium">{member.credentials}</span>
                    </div>
                    <div className="px-4 py-2 rounded-full bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] text-sm font-medium inline-block">
                      {member.specialty}
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
       
      </div>
    </section>
  );
};